import React, { FC } from 'react';
import { EnterItHelpToType } from 'types/components';
import {
    Container,
    Description,
    DescriptionPart,
    Image,
    ImageContainer,
    Title,
} from './styled';
import { RegisterButton } from 'containers/pages/profession-item/components/intro/styled';

export const EnterItHelpItem: FC<
    EnterItHelpToType & { fullWidth?: boolean; index: number }
> = ({
    title,
    description,
    imageUrl,
    downloadUrl,
    downloadTitle,
    fullWidth,
    index,
    showDownloadButton,
}) => (
    <Container index={index}>
        <DescriptionPart fullWidth={fullWidth}>
            <Title variant={'h4'}>{title}</Title>
            <Description variant={'p2'}>{description}</Description>
        </DescriptionPart>
        <ImageContainer>
            {downloadTitle && downloadUrl && showDownloadButton && (
                <RegisterButton
                    onClick={() => window.open(downloadUrl)}
                    variant={'contained'}
                    color={'primary-contrast'}
                    size={'medium'}>
                    {downloadTitle}
                </RegisterButton>
            )}
            <Image imageUrl={imageUrl} fullWidth={fullWidth} />
        </ImageContainer>
    </Container>
);
